// ── PLATFORM ADAPTER (web) ────────────────────────────────────────────────────
// Install / standalone detection. iOS web push ONLY works once the PWA is added
// to the Home Screen (standalone) — so the push UX is gated on this. On native
// (RN/Expo) install/standalone is moot; this whole file is replaced by native
// notification-permission checks.

export function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    // iOS Safari exposes this non-standard flag on navigator
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}

export function isIOS(): boolean {
  const ua = window.navigator.userAgent
  const iOSDevice = /iPad|iPhone|iPod/.test(ua)
  // iPadOS 13+ reports as Mac; detect touch + Mac platform.
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  return iOSDevice || iPadOS
}

export function pushSupported(): boolean {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
}
